import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Field } from "formik";
import { Link, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import ReactSVG from "react-svg";
import CEPSearch from "~/assets/img/icon/cep-search.svg"
import { Grid } from "@material-ui/core";
import {
  Title,
  Text,
  Margin,
  Input,
  Button,
  Select,
  Checkbox,
  Message,
  ErrorMessage,
  Loading,
} from "~/components/elements";
import { schema } from "./validation";
import { Creators as SignUpActions } from "~/store/modules/signUp/actions";
import { Creators as PromoActions } from "~/store/modules/promo/actions";
import {
  zipCodeMask,
  phoneWithoutDDDMask,
  dddMask,
  removeMask
} from "~/utils/tools";
import { ufSelect, phoneTypeSelect } from "~/utils/variables";
import isMobile from "~/hooks/isMobile";
import axios from "axios";

import * as S from "./styles";

export default function FormSignUpComplement() {
  const mobile = isMobile();
  const dispatch = useDispatch();
  const location = useLocation();
  const [cepNotFound, setCepNotFound] = useState(false);
  const [loadingCep, setLoadingCep] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const paramObj = {};
    for (const [key, value] of queryParams.entries()) {
      paramObj[key] = value;
    }
  }, [location]);


  const sending = useSelector((state) => state.signUp.sign.sending);
  const errorMessage = useSelector((state) => state.signUp.sign.errorMessage);
  const address = useSelector((state) => state.account.zipCode.address);
  const initialValues = {
    ParticipanteHash: useSelector(
      (state) => state.authentication.auth.user.ParticipanteHash
    ),
    Nome: "",
    DataNascimento: "",
    Documento: "",
    Email: "",
    ConfirmaEmail: "",
    Senha: "",
    ConfirmaSenha: "",
    Estado: ufSelect[0],
    DDDTelefone: "",
    Telefone: "",
    TelefoneTipo: phoneTypeSelect[0],
    AceitaRegulamento: 0,
    AceitaReceberNoticias: 0,
    AceitaPoliticaDePrivacidade: 0,
    AceitaTermosLegais: 0,
    Instagram: "",
    Cidade: "",
    Endereco: "",
    Numero: "",
    Complemento: "",
    Cep: "",
    Bairro: ""
  };

  const url = process.env.REACT_APP_HOST_URL;
  const origin = process.env.REACT_APP_ORIGIN;

  const getUF = (uf) => {
    if (!uf) return ufSelect[0];
    return ufSelect?.find((data) => data.value === uf);
  };

  return (
    <S.FormHolder>
      <Margin mb={3}>
        <Formik
          initialValues={initialValues}
          validationSchema={schema}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(false);
            dispatch(SignUpActions.setSignUpData());
            const payloadValues = {
              ...values,
              AceitaReceberNoticias:
                values.AceitaReceberNoticias &&
                values.AceitaReceberNoticias.length > 0
                  ? true
                  : false,
              AceitaTermosLegais:
                values.AceitaTermosLegais &&
                values.AceitaTermosLegais.length > 0
                  ? true
                  : false,
              AceitaRegulamento:
                values.AceitaRegulamento && values.AceitaRegulamento.length > 0
                  ? true
                  : false,
              Estado: values.Estado.value,
              DddResidencial:
                values.TelefoneTipo?.value === "1" ? values.DDDTelefone : "",
              TelResidencial:
                values.TelefoneTipo?.value === "1" ? values.Telefone : "",
              DddComercial:
                values.TelefoneTipo?.value === "2" ? values.DDDTelefone : "",
              TelComercial:
                values.TelefoneTipo?.value === "2" ? values.Telefone : "",
              DddCelular:
                values.TelefoneTipo?.value === "3" ? values.DDDTelefone : "",
              TelCelular:
                values.TelefoneTipo?.value === "3" ? values.Telefone : "",
              Url: url,
              Origin: origin,
            };
            delete payloadValues.ConfirmaEmail;
            delete payloadValues.ConfirmaSenha;
            delete payloadValues.TelefoneTipo;
            delete payloadValues.DDDTelefone;
            delete payloadValues.Telefone;
            // delete payloadValues.AceitaRegulamento;
            delete payloadValues.AceitaPoliticaDePrivacidade;
            if (initialValues.ParticipanteHash) {
              dispatch(PromoActions.setRegisterStep(2));
            }
            dispatch(SignUpActions.sendSignUpForm(payloadValues));
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isValid,
            dirty,
          }) => (
            <S.FormLimiter onSubmit={handleSubmit}>
              <Margin mb={mobile ? 3 : 2}>
                <Title
                  as="2"
                  levelDesktop="6"
                  level="6"
                  primary
                  emphasis={false}
                >
                  <strong>Informações de contato</strong>
                </Title>
              </Margin>
              <Margin mb={mobile ? 4 : 3}>
                <Input
                  label="Instagram"
                  placeholder="@seu_perfil"
                  htmlFor="nameFieldFormSignup"
                  name="Instagram"
                  required
                  value={values.Instagram}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  errors={touched.Instagram && errors.Instagram}
                  valid={!errors.Instagram}
                />
              </Margin>
              <Margin mt={mobile ? 1 : 2}>
                <S.PhoneTitle>
                  <strong>Telefone*</strong>
                </S.PhoneTitle>
              </Margin>
              <Grid container>
                <Grid item xs={3} md={2}>
                  <Margin mb={mobile ? 0 : 4} mr={1}>
                    <Input
                      mask={dddMask}
                      placeholder="DDD"
                      htmlFor="phonedddFieldFormSignup"
                      name="DDDTelefone"
                      value={values.DDDTelefone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errors={touched.DDDTelefone && errors.DDDTelefone}
                      valid={!errors.DDDTelefone}
                    />
                  </Margin>
                </Grid>
                <Grid item xs={9} md={6}>
                  <Margin mb={4} mr={mobile ? 0 : 1}>
                    <Input
                      mask={phoneWithoutDDDMask}
                      placeholder="00000-0000"
                      htmlFor="phoneFieldFormSignup"
                      name="Telefone"
                      value={values.Telefone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errors={touched.Telefone && errors.Telefone}
                      valid={!errors.Telefone}
                    />
                  </Margin>
                </Grid>

                <Grid item xs={12} md={4} style={{ order: mobile ? -1 : 'initial' }}>
                  <Margin mb={mobile ? 0 : 4}>
                    <Select
                      name="TelefoneTipo"
                      placeholder="Residencial"
                      onChange={setFieldValue}
                      onBlur={handleBlur}
                      value={values.TelefoneTipo}
                      errors={touched.TelefoneTipo && errors.TelefoneTipo}
                      valid={!errors.TelefoneTipo}
                      options={phoneTypeSelect}
                      id="phoneTypeFieldFormSignup"
                    />
                  </Margin>
                </Grid>
              </Grid>
              
              <Grid container justifyContent="center">
                <Grid item xs={12} md={12}>
                  <Margin mb={mobile ? 2 : 3}>
                    <S.InputCep>
                      <Input
                        mask={zipCodeMask}
                        label="CEP"
                        placeholder="Digite o seu CEP"
                        htmlFor="zipCodeFieldFormSignup"
                        name="Cep"
                        required
                        value={values.Cep}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        errors={
                          touched.Cep && (errors.Cep)
                        }
                      />
                      <S.FindCep
                        onClick={async () => {
                          setLoadingCep(true);
                          const { data } = await axios.get(
                            `https://viacep.com.br/ws/${values.Cep}/json`
                          );
                          if (data?.erro) {
                            setCepNotFound(true);
                          } else {
                            setCepNotFound(false);
                            const uf = getUF(data?.uf);
                            setFieldValue("Estado", uf);
                            setFieldValue("Endereco", data?.logradouro);
                            setFieldValue("Cidade", data?.localidade);
                            setFieldValue("Bairro", data?.bairro);
                          }

                          setLoadingCep(false);
                        }}
                        disabled={removeMask(values.Cep)?.length <= 7}
                        color={
                          !values.Cep ||
                          removeMask(values.Cep)?.length <= 7 ||
                          loadingCep
                            ? "disabled"
                            : "primary"
                        }
                        id="zipcodeButtonFormSignup"
                      >
                        {loadingCep ? <S.CepLoading><Loading /></S.CepLoading> : <ReactSVG src={CEPSearch} />}
                      </S.FindCep>
                    </S.InputCep>
                    <S.FindCepLink
                      target="_blank"
                      href="https://buscacepinter.correios.com.br/app/endereco/index.php"
                    >
                      <Text level="1" primary>
                        Não sei o cep
                      </Text>
                    </S.FindCepLink>
                  </Margin>
                </Grid>
                {cepNotFound && (
                  <Grid item xs={12} md={8}>
                    <Margin mb={mobile ? 2 : 4}>
                      <ErrorMessage>Cep não encontrado</ErrorMessage>
                    </Margin>
                  </Grid>
                )}
              </Grid>
              <Grid container>
                <Grid item xs={9} md={9}>
                  <Margin mb={0} mr={1}>
                    <Input
                      label="Endereço"
                      placeholder="Rua"
                      htmlFor="streetFieldFormSignup"
                      name="Endereco"
                      required
                      value={values.Endereco}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errors={touched.Endereco && errors.Endereco}
                      valid={!errors.Endereco}
                    />
                  </Margin>
                </Grid>
                <Grid item xs={3} md={3}>
                  <Margin mb={0} mt={3}>
                    <Input
                      placeholder="Número"
                      htmlFor="streetNumberFieldFormSignup"
                      name="Numero"
                      required
                      value={values.Numero}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errors={touched.Numero && errors.Numero}
                      valid={!errors.Numero}
                    />
                  </Margin>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12} md={6}>
                  <Margin mb={mobile ? 0 : 0} mr={mobile ? 0 : 1} mt={-1}>
                    <Input
                      placeholder="Complemento"
                      htmlFor="streetComplementFieldFormSignup"
                      name="Complemento"
                      value={values.Complemento}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errors={touched.Complemento && errors.Complemento}
                      valid={!errors.Complemento}
                    />
                  </Margin>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Margin mb={mobile ? 0 : 0} mt={-1}>
                    <Input
                      placeholder="Bairro"
                      htmlFor="streetBairroFieldFormSignup"
                      name="Bairro"
                      value={values.Bairro}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errors={touched.Bairro && errors.Bairro}
                      valid={!errors.Bairro}
                    />
                  </Margin>
                </Grid>
                <Grid item xs={12} md={7}>
                  <Margin mb={mobile ? 0 : 0} mr={mobile ? 0 : 1} mt={-1}>
                    <Input
                      placeholder="Cidade"
                      htmlFor="cityFieldFormSignup"
                      required
                      name="Cidade"
                      value={values.Cidade}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errors={touched.Cidade && errors.Cidade}
                      valid={!errors.Cidade}
                    />
                  </Margin>
                </Grid>
                <Grid item xs={12} md={5}>
                  <Margin mb={mobile ? 0 : 2} mt={-1}>
                    <Select
                      name="Estado"
                      placeholder="UF"
                      onChange={setFieldValue}
                      onBlur={handleBlur}
                      value={address.uf ? getUF(address.uf) : values.Estado}
                      errors={touched.Estado && errors.Estado}
                      valid={!errors.Estado}
                      options={ufSelect}
                      required
                      id="stateFieldFormSignup"
                    />
                  </Margin>
                </Grid>
              </Grid>
              

              <Margin mt={mobile ? 6 : 3} mb={mobile ? 6 : 4}>
                <S.TermsHolder>
                  <S.TextContainer>
                  JNTL Consumer Health (Brazil) Ltda  está comprometida com o respeito à sua privacidade e reconhece a importância do tratamento adequado de suas informações. Portanto, informamos que os dados pessoais fornecidos neste formulário serão coletados e utilizados por nós para (i) validar e prosseguir com a sua participação na promoção de "Johnsons Baby" (Bebê Johnson's): ii) enviar informações relacionadas aos nossos produtos, serviços e outras ativações. Para mais informações sobre como tratamos seus dados pessoais e como exercer seus direitos como titulares de dados, consulte nossa Política de Privacidade disponível em: {" "}
                  <a href="https://www.johnsonsbaby.com.br/politica-de-privacidade"
                          target="_blank"
                          rel="noopener noreferrer">Política de privacidade</a>

                  </S.TextContainer>
                  <Margin mb={2}>
                    <Title level="6" primary>
                      <strong>Termos de aceite</strong>
                    </Title>
                  </Margin>
                  <Margin mb={2}>
                    <S.LabelRadio
                    underlineLink
                      error={
                        errors.AceitaPoliticaDePrivacidade &&
                        errors.AceitaPoliticaDePrivacidade.length < 50
                      }
                    >
                      <Field
                        component={Checkbox}
                        type="checkbox"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        name="AceitaPoliticaDePrivacidade"
                        value="1"
                        id="privacityCheckFormSignup"
                      />
                      <Text level="2">
                      Reconheço que li, compreendi e aceito o presente Aviso de Privacidade e a{" "}
                        <a
                          href="https://www.johnsonsbaby.com.br/politica-de-privacidade"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Política de Privacidade.
                        </a>
                      </Text>
                    </S.LabelRadio>

                    {errors.AceitaPoliticaDePrivacidade &&
                      errors.AceitaPoliticaDePrivacidade.length < 50 && (
                        <Message variant="error">
                          {errors.AceitaPoliticaDePrivacidade}
                        </Message>
                      )}
                  </Margin>

                  <Margin mb={2}>
                    <S.LabelRadio
                      underlineLink
                      error={
                        errors.AceitaRegulamento &&
                        errors.AceitaRegulamento.length < 50
                      }
                    >
                      <Field
                        component={Checkbox}
                        type="checkbox"
                        name="AceitaRegulamento"
                        value="1"
                        id="regulamentCheckFormSignup"
                        valid={
                          errors.AceitaRegulamento && touched.AceitaRegulamento
                        }
                      />
                      <Text level="2">
                        Li e concordo com o{" "}
                        <Link
                          to={`/regulamento#conteudo${location.search}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Regulamento.
                        </Link>
                      </Text>
                    </S.LabelRadio>
                    {errors.AceitaRegulamento &&
                      errors.AceitaRegulamento.length < 50 && (
                        <Message variant="error">
                          {errors.AceitaRegulamento}
                        </Message>
                      )}
                  </Margin>

                  <Margin mb={2} mr={mobile ? 0 : 4}>
                    <S.LabelRadio>
                      <Field
                        component={Checkbox}
                        type="checkbox"
                        name="AceitaReceberNoticias"
                        value="1"
                        id="newsCheckFormSignup"
                      />
                      <Text level="2">
                        Autorizo o processamento dos meus Dados Pessoais para os fins descritos no Aviso de Autorização e transferência dos meus Dados Pessoais fora do meu país de residência para empresas afiliadas da Kenvue do Brasil Indústria e Comércio de Produtos para Saúde Ltda em outras jurisdições. Incluindo os Estados Unidos, ou para empresas que prestam serviços para cumprir as finalidades descritas no Aviso de Privacidade.
                      </Text>
                    </S.LabelRadio>
                  </Margin>

                  <Margin mb={2}>
                    <S.LabelRadio
                      error={
                        errors.AceitaTermosLegais &&
                        errors.AceitaTermosLegais.length < 50
                      }
                      underlineLink
                    >
                      <Field
                        component={Checkbox}
                        type="checkbox"
                        name="AceitaTermosLegais"
                        value="1"
                        id="legalCheckFormSignup"
                      />
                      <Text level="2">
                        Li e concordo com os{" "}
                        <HashLink
                          smooth
                          target="_blank"
                          to="/informacoes-legais#conteudo"
                        >
                          Termos legais.
                        </HashLink>
                      </Text>
                    </S.LabelRadio>
                    {errors.AceitaTermosLegais &&
                      errors.AceitaTermosLegais.length < 50 && (
                        <Message variant="error">
                          {errors.AceitaTermosLegais}
                        </Message>
                      )}
                  </Margin>
                </S.TermsHolder>
              </Margin>
              <S.ButtonsGrid
                container
                justifyContent="space-between"
                direction={mobile ? "column-reverse" : "row"}
              >
                <Margin mb={mobile ? 3 : 0}>
                  <Button
                    className="animation-size"
                    color={
                      !isValid || !dirty || sending
                        ? "disabled"
                        : "primary"
                    }
                    disabled={!isValid || !dirty || sending}
                    type="submit"
                    id="nextButtonFormSignup"
                  >
                    {sending ? <Loading button /> : "AVANÇAR >"}
                  </Button>
                </Margin>
              </S.ButtonsGrid>
              {errorMessage && (
                <Margin mt={mobile ? 3 : 5}>
                  <ErrorMessage>{errorMessage}</ErrorMessage>
                </Margin>
              )}
            </S.FormLimiter>
          )}
        </Formik>
      </Margin>
    </S.FormHolder>
  );
}
